<template>
    <div class="centerhome">
      <div class="u-flex u-flex-start centerhome_top">
          <img style="border-radius: 50%;" :src="userInfo.userInfo.avatar" alt="" srcset="">
          <div class="user_topcontent u-flex-y u-flex-between">
              <div class="ch_title">
                  {{userInfo.userInfo?userInfo.userInfo.nickname:''}}
              </div>
              <div class="userinfo_msg u-flex u-flex-start" v-if="userInfo.userInfo">
                <div><b>{{videoDataInfo[2].count}}</b> 获赞</div>
                <div> <b>{{userInfo.userInfo.relation.follows}}</b> 关注</div>
                <div> <b>{{userInfo.userInfo.relation.fans}}</b> 粉丝</div>
                <div>龙珠号 <b>{{userInfo.userInfo.account}}</b></div>
              </div>
              <div class="user_discript" v-if="userInfo.userInfo">
                个人简介：<span>{{userInfo.userInfo.desc}}</span>
              </div>
          </div>
      </div>
      <div class="user_data">
          <div class="slidetabs u-flex u-flex-items-center">
            <div class="itemstab " @click="navtabchange(1)" :class="activeIndex==1?'activetabs':''">
              直播数据
            </div>
            <div class="itemstab u-flex-y u-flex-center"   :class="activeIndex==2?'activetabs':''" @click="navtabchange(2)" >
              视频数据
            </div>
            <div class="selectTime" v-if="activeIndex ==1">
               <el-date-picker
                    v-model="dataTime"
                    type="date"
                    @change='changeTime'
                    placeholder="选择日期">
                  </el-date-picker>
            </div>
          </div>
          <div class="datalist u-flex" v-if="activeIndex == 1">
              <div class="proitems u-flex-y" v-for="(items,index) in datalist" :class="index>2?'nomargin':''" :key="index">
                 <div>{{items.name}}</div>
                 <div class="nums">{{items.count}}</div>
              </div>
          </div>
          <div  class="datalist u-flex" v-else>
            <div class="proitems u-flex-y" v-for="(items,index) in videoDataInfo" :class="index>2?'nomargin':''" :key="index">
                <div>{{items.name}}</div>
                <div class="nums">{{items.count?items.count:0}}</div>
            </div>
          </div>
      </div>
      <div class="hotlistbox">
        <div class="hvname">
          热门视频
        </div>
        <div class="hotVideolist" v-if="hotVideoList.length>0">
            <div class="hotvalueitem" v-for="(item,index) in hotVideoList" :key="index">
              <div class="hotvideoImg">
                <img :src="item.playRelationData.videoInfo.coverImg" alt="" srcset="">
              </div>
              <div class="hotitemmsg">
                  <div class="hvtitle myfontwidth2">
                    {{item.playRelationData.videoInfo.videoContent}}
                  </div>
                  <div class="hbnumber">
                    {{item.playRelationData.videoExtra.playNum}}次播放
                  </div>
              </div>
            </div>
        </div>
      </div>

    </div>
</template>
<script>

  import moment from 'moment';

  import {
     statisticALL,videoHotList,livedatas,getUserInfo,
  } from '@/api/video.js'
export default {
    data(){
        return {
            userInfo:{},
            dataTime:'',
            hotVideoList:[],
            activeIndex:1,
            datalist:[
              {
                name:'直播时长',
                count:0
              },
              // {
              //   name:'观看人数',
              //   count:0
              // },
              {
                name:'新增粉丝',
                count:0
              },
              {
                name:'在线人数峰值',
                count:0
              },
              {
                name:'人均观看时长',
                count:0
              },
              {
                name:'直播热度',
                count:0
              },
              {
                name:'直播收益',
                count:0
              }
            ],
            videoDataInfo:[
              {
                name:'播放总量',
                count:'',
              },{
                name:'视频分享数',
                count:''
              },{
                name:'视频点赞数',
                count:''
              },
              {
                name:'新增粉丝数',
                count:'',
              },
              {
                name:'视频评论数',
                count:'',
              }
            ]
        }
    },
    created() {
      this.initdata();
      this.dataTime = moment().format('YYYY-MM-DD')
    },
    methods:{
      changeTime(e){
        console.log(e,moment(this.dataTime).format('YYYY-MM-DD'), moment(this.dataTime).subtract(1, 'day').format('YYYY-MM-DD'));
        this.getVideoData()
      },
      async initdata(){
          // 用户信息
          let userInfo = await getUserInfo({})
          if(userInfo.data && userInfo.data.code == 200){
            this.userInfo = userInfo.data.data;
            console.log('用户信息',this.userInfo);
          }
          let result = await  statisticALL({});
          console.log('视频数据',result);
          if(result.data && result.data.code == 200 &&  result.data.data){
            let { commentNum,likeNum,playEndNum,playNum,shareNum,statisticId,uId} = result.data.data;
            this.videoDataInfo[0].count = playNum;
            this.videoDataInfo[1].count = shareNum
            this.videoDataInfo[2].count = likeNum
            this.videoDataInfo[3].count = commentNum
            this.videoDataInfo[4].count = commentNum
            this.datalist[5].count = likeNum
          }
          // 热门视频
          let res = await videoHotList({});
          if(res.data && res.data.code == 200){
            this.hotVideoList = res.data.data
          }
          this.getVideoData()
      },
      async getVideoData(){
        // 直播数据
        let liveDatas = await livedatas({
          endTime:moment(moment(this.dataTime).format('YYYY-MM-DD')).unix().valueOf(),
          startTime:moment(moment(this.dataTime).subtract(1, 'day').format('YYYY-MM-DD')).unix().valueOf(),
        })
        console.log('直播数据',liveDatas);
        if(liveDatas.data.code == 200){

            if(liveDatas.data.data && liveDatas.data.data.length> 0){
              let {onlineNum,income,follow,endTime,startTime,heatValue} = liveDatas.data.data[0];
              let start = moment(startTime * 1000).format('YYYY-MM-DD HH:mm:ss');
              let end = moment(endTime * 1000).format('YYYY-MM-DD HH:mm:ss');
              console.log('开始时间',start,'结束时间',end);
              let datetime = moment(end).diff(moment(start),'minute');
              if(datetime  < 0){
                datetime = 0
              }
              console.log('直播时常',datetime);
              this.datalist[0].count = (datetime / 60 ).toFixed(2) + 'h'
              this.datalist[2].count = onlineNum  //
              this.datalist[1].count = follow // 关注
              this.datalist[3].count = ( (datetime / (onlineNum?onlineNum:1)) / 60).toFixed(2) + 'h'
              this.datalist[4].count = heatValue
              this.datalist[5].count = income
            }else{
              this.datalist[0].count = 0
              this.datalist[2].count = 0  //
              this.datalist[1].count = 0 // 关注
              this.datalist[3].count =0
              this.datalist[4].count = 0
            }

            // this.datalist[5].count = datetime


            // "createTime": 123456, //创建的时间戳
            // "title": "本场直播标题",
            // "categoryName": "本场开播分类名",

            // "onlineNum": 100, //本场峰值在线人数

            // "income": "123", //本场收益
            // "startTime":123456,  //开始时间
            // "endTime":123456,	//结束时间
            // "follow":123, // 本场新增关注数
            // "gift":1234,  // 本场峰值送礼人数
            // "heatValue": 1234 // 本场峰值热度
        }
      },
      // 切换
      navtabchange(e){
        this.activeIndex = e;
        // 请求数据
        this.initdata()
      }
    }
}
</script>

<style lang="scss">
  @import '../../assets/style/flex.scss';
  .centerhome{
    width: calc(1200px - 202px);
    box-sizing: border-box;
    height: calc(100vh - 130px);
    overflow-y: scroll;
    .hotlistbox{
      background: #FFFFFF;
      border-radius: 6px;
      margin-top: 24px;
      padding:24px 24px 0;
      .hvname{
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        padding-bottom: 24px;
      }
      .hotVideolist{
        display: flex;
        // overflow-x: scroll;
        padding-bottom: 24px;
        .hotvalueitem:last-child{
          margin-right: 0 !important;
        }
        .hotvalueitem{
          margin-right: 12px;
          width: 180px;
          .hbnumber{
            margin-top: 6px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #999999;
          }
          .hotitemmsg{
            margin-top:8px;
            height:68px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .hvtitle{
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #333333;
            }
          }
          .hotvideoImg{
            height: 240px;
            overflow: hidden;
            width: 180px;
            border-radius: 8px;
            text-align: center;
            background-color: #f2f3f4;
            img{
              background-color: rgba(0, 0,0, .1);
              height: 240px;
              border-radius: 8px;
            }
          }

        }
      }
    }

    .datalist{
      padding: 24px 0;
      flex-flow: row wrap;

      .nomargin{
        margin-bottom: 0 !important;
      }
      .proitems{
        display: flex;
        justify-content: center;
          padding: 24px;
          box-sizing: border-box;
          width: 303px;
          height: 158px;
          background: #F7F8FA;
          border-radius: 8px;
          margin:0 12px 12px 0;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          .nums{
            margin-top: 4px;
            font-size: 30px;
          }
      }
    }
    .selectTime{
      flex: 2;
      display:flex;
      justify-content: flex-end;
    }
    .user_data{
      background-color: #fff;
      margin-top: 12px;
      padding:0 24px ;
      border-radius: 6px;
      .slidetabs{
        padding: 24px 0;
        height:36px;
            border-bottom: 1px solid rgba(0, 0,0, .1);
            .activetabs{
              color: #333333 !important;
            }
            .itemstab{
              cursor: pointer;
              font-size: 20px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #999;
              margin-right: 30px;
            }
          }
    }

    .centerhome_top{
      padding: 24px;
      background-color: #fff;
      border-radius:6px;
      img{
        width: 80px;
        height: 80px;
        margin-right: 12px;
      }
      .ch_title{
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #333333;
      }
      .user_discript{
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
      }
      .userinfo_msg{
        b{
          color: #333;
          font-weight: 400;
          margin-right: 2px;
        }
        div{
          display:flex;
         margin-right:2vw;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
        }
      }
    }


  }
</style>



// WEBPACK FOOTER //
// src/pages/template/centerContent.vue